import script from "./holeOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./holeOverview.vue?vue&type=script&setup=true&lang=js"

import "./holeOverview.vue?vue&type=style&index=0&id=6277485f&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6277485f"]])

export default __exports__